import React, { useEffect } from 'react';
import type { FC } from 'react';
import { useParams } from 'react-router';

import { Spinner } from '@admin/components/spinner';
import { orderURL } from '@admin/config/routes';
import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useOrderRedirectQuery } from '@admin/schema';

export const OrderRedirect: FC = () => {
  useTitle('Order');
  const { orderID } = useParams<{ orderID: string }>();
  const navigate = useNavigate();
  const { data } = useOrderRedirectQuery({
    client,
    variables: { orderID: String(orderID) },
  });

  useEffect(() => {
    if (!data) return;
    navigate(data?.order ? orderURL(data.order) : '/');
  }, [data, navigate]);

  return <Spinner />;
};
